import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var Title = function Title(_ref) {
  var children = _ref.children,
    className = _ref.className,
    isWithSubtitle = _ref.isWithSubtitle,
    extraAttributes = _ref.extraAttributes;
  return /*#__PURE__*/React.createElement(Text, {
    className: cn(className || 'title', {
      'title-with-subtitle': isWithSubtitle
    }),
    extraAttributes: extraAttributes,
    size: "size1-m",
    tagType: "h2",
    "data-t-id": "components-Title"
  }, children);
};
export { Title };